import http from './request';

// 我的消息列表
export async function messageListServer(data = {}) {
    return http({
        url: 'user/message-list',
        params: data,
        method: 'GET',
        loading: true,
    });
}

// 我点赞过的动态列表
export async function praisePostsListServer(data = {}) {
    return http({
        url: 'user/praise-posts',
        params: data,
        method: 'GET',
        loading: true,
    });
}

// 我评论过的动态列表
export async function replyPostsListServer(data = {}) {
    return http({
        url: 'user/reply-posts',
        params: data,
        method: 'GET',
        loading: true,
    });
}

// 我的私信列表
export async function privateMessageListServer(data = {}) {
    return http({
        url: 'user/private-message-list',
        params: data,
        method: 'GET',
        loading: true,
    });
}

// 我和某个用户的私信列表
export async function chatListListServer(data = {}) {
    return http({
        url: 'user/chat-list',
        params: data,
        method: 'GET',
        loading: true,
    });
}
// 发送私信
export async function sendChatServer(data = {}) {
    return http({
        url: 'user/send-private-message',
        data,
        loading: true,
    });
}
// 标记某条消息为已读
export async function messageReadServer(data = {}) {
    return http({
        url: 'user/message-read',
        params: data,
        method: 'GET',
        loading: false,
    });
}

// 标记某条消息为已读
export async function messageAllReadServer(data = {}) {
    return http({
        url: 'user/message-read-all',
        params: data,
        method: 'GET',
        loading: false,
    });
}

// 删除全部消息
export async function deleteAllMessageServer(data = {}) {
    return http({
        url: 'user/message-delete-all',
        params: data,
        method: 'GET',
        loading: true,
    });
}
// 删除某一条消息
export async function deleteOneMessageServer(data = {}) {
    return http({
        url: 'user/message-delete-one',
        params: data,
        method: 'GET',
        loading: true,
    });
}

// 57.未读消息数
export async function unReadMessageCountServer(data = {}) {
    return http({
        url: 'user/unread-message-num',
        params: data,
        method: 'GET',
        loading: false,
    });
}

// 51.删除和某个用户的私信
export async function deletePrivateMessageServer(data = {}) {
    return http({
        url: 'user/delete-private-message',
        params: data,
        method: 'GET',
        loading: false,
    });
}
